import React, { useState } from "react";
import styled from "styled-components";
import { FaShieldAlt } from "react-icons/fa";

const guinda = "#611232";

export default function AvisoPrivacidad() {
  const [isOpen, setIsOpen] = useState(true);

  const handleAceptar = () => {
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <Overlay>
      <ModalContent>
        <Header>
          <IconWrapper>
            <FaShieldAlt />
          </IconWrapper>
          <h2>Aviso de Privacidad</h2>
        </Header>
        
        <Body>
          <p><strong>Términos y Condiciones</strong></p>
          <ol>
            <li>El presente Aviso de Privacidad tiene por objeto la protección de los datos personales de toda persona que solicite nuestros servicios profesionales (personal directivo, personal administrativo), mediante su tratamiento legítimo, controlado e informado, a efecto de garantizar su privacidad, así como su derecho a la autodeterminación informativa.</li>
            <li>Dato Personal es cualquier información concerniente a una persona física identificada o identificable.</li>
            <li>Al proporcionar sus Datos Personales por escrito, a través de una solicitud, formato en papel, formato digital, correo electrónico, o cualquier otro documento, usted acepta y autoriza a CAMPAÑA INTEGRAL DE DENUNCIA CIUDADANA S.C a utilizar y tratar de forma automatizada sus datos personales e información suministrados, los cuales formarán parte de nuestra base de datos con la finalidad de usarlos, en forma enunciativa, más no limitativa, para: identificarle, ubicarle, comunicarle, contactarle y enviarle información, por cualquier medio que permita la ley, para cumplir con nuestros fines sociales. Mediante la aceptación y autorización para el tratamiento de sus datos personales en los términos antes señalados, nos faculta expresamente a transferirlos a autoridades de cualquier nivel (Federales, Estatales, Municipales), organismos públicos y privados.</li>
            <li>La temporalidad del manejo de sus Datos Personales será indefinida a partir de la fecha en que nos los proporcione, con las limitaciones de Ley.</li>
            <li>CAMPAÑA INTEGRAL DE DENUNCIA CIUDADANA S.C es responsable del tratamiento de sus datos personales y está obligada a cumplir con los principios de licitud, consentimiento, información, calidad, finalidad, lealtad, proporcionalidad y responsabilidad tutelados en la LEY FEDERAL DE PROTECCIÓN DE DATOS PERSONALES EN POSESIÓN DE LOS PARTICULARES; por tal motivo se compromete a guardar estricta confidencialidad de sus datos personales, así como a mantener las medidas de seguridad administrativas, técnicas y físicas que permitan protegerlos contra cualquier daño, pérdida, alteración, acceso o tratamiento no autorizado.</li>
            <li>En términos de lo establecido por el artículo 22 de la LEY FEDERAL DE PROTECCIÓN DE DATOS PERSONALES EN POSESIÓN DE LOS PARTICULARES, usted tiene derecho en cualquier momento a ejercer sus derechos de acceso, rectificación, cancelación y oposición al tratamiento de sus datos personales, mediante solicitud vía correo electrónico dirigido a ciddecadministracion@gmail.com, o por escrito en el domicilio ubicado en Bosque de alisos 45, Cuajimalpa de Morelos, 01520, Ciudad de México, México.</li>
            <li>CAMPAÑA INTEGRAL DE DENUNCIA CIUDADANA S.C protegerá sus Datos Personales en los términos de las fracciones del artículo 16 de la LEY FEDERAL DE PROTECCIÓN DE DATOS PERSONALES EN POSESIÓN DE LOS PARTICULARES.</li>
          </ol>
        </Body>

        <Footer>
          <SubmitButton onClick={handleAceptar}>
            He leído y acepto los términos
          </SubmitButton>
        </Footer>
      </ModalContent>
    </Overlay>
  );
}

// STYLED COMPONENTS
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000; /* Sobreponer a casi todo */
  padding: 1.5rem;
`;

const ModalContent = styled.div`
  background: white;
  width: 100%;
  max-width: 650px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  padding: 2.5rem 2rem;
  border-radius: 2rem;
  position: relative;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 1.5rem;
  flex-shrink: 0;
  h2 {
    margin: 0 0 0.5rem;
    font-weight: 900;
    color: #1a1a1a;
  }
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 50px;
  background: ${guinda};
  color: white;
  border-radius: 14px;
  display: grid;
  place-items: center;
  font-size: 1.5rem;
  margin: 0 auto 1rem;
`;

const Body = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding-right: 10px;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
  line-height: 1.6;
  color: #444;

  p {
    margin-top: 0;
  }

  ol {
    padding-left: 1.2rem;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin: 0;
  }

  /* Custom Scrollbar for inner body */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1; 
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc; 
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #999; 
  }
`;

const Footer = styled.div`
  flex-shrink: 0;
  text-align: center;
`;

const SubmitButton = styled.button`
  background: ${guinda};
  color: white;
  border: none;
  padding: 1.1rem 2rem;
  border-radius: 15px;
  font-size: 1rem;
  font-weight: 800;
  cursor: pointer;
  width: 100%;
  transition: opacity 0.3s ease, transform 0.2s ease;

  &:hover {
    opacity: 0.9;
  }
  
  &:active {
    transform: scale(0.98);
  }
`;
